import PassiveAura from "@/roc/effects/PassiveAura/PassiveAura";
import EraType from "@/roc/era/EraType";
import PassiveProduction from "@/roc/effects/Production/PassiveProduction";
export function applyWonderSynergies(wonder, level, effectIndex, callback) {
    for (let i = 0; i < wonder.synergies.length; i++) {
        if (wonder.synergies[i].effectIndex === effectIndex) {
            const effectFromSynergy = wonder.synergies[i].effect?.effect;
            if (effectFromSynergy instanceof PassiveAura) {
                const sAm = effectFromSynergy.getAmount(level, EraType.stoneAge);
                if (sAm) {
                    callback(effectFromSynergy, sAm * (wonder.synergies[i].effect?.getMultiplier() || 0));
                }
            }
            else if (effectFromSynergy instanceof PassiveProduction) {
                const sAm = effectFromSynergy.production(level, EraType.stoneAge);
                if (sAm) {
                    callback(effectFromSynergy, sAm.amount / sAm.duration * (wonder.synergies[i].effect?.getMultiplier() || 0));
                }
            }
            break;
        }
    }
}
